import React, { useState, useEffect } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'
import { FilingSourceTypeIds } from '../../../../Utilities/Utilities'

const ReceiptItemToFilingTypeOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)

  const [recordTypeOptions, setRecordTypeOptions] = useState([{ label: 'All', value: '0' }])
  const [miscellaneousModuleOptions, setMiscellaneousModuleOptions] = useState([{ label: 'All', value: '0' }])
  const [sourceTypeOptions, setSourceTypeOptions] = useState([])
  const [filingTypeOptions, setFilingTypeOptions] = useState([{ label: 'All', value: '0' }])
  const [recordSubTypeOptions, setRecordSubTypeOptions] = useState([{ label: 'None', value: '0' }])
  const [recordSubTypeXref, setRecordSubTypeXref] = useState([])
  const [sourceType, setSourceType] = useState(optionalData.sourceType || 0)
  const [recordType, setRecordType] = useState(optionalData.recordType || 0)
  const [miscellaneousModule, setMiscellaneousModule] = useState(optionalData.miscellaneousModule || 0)
  const [filingType, setFilingType] = useState(optionalData.filingType || 0)
  const [recordSubType, setRecordSubType] = useState(optionalData.recordSubType || 0)
  const [loading, setLoading] = useState(false)
  const [optionsLoading, setOptionsLoading] = useState(false)
  const [orderSourceType, setOrderSourceType] = useState(optionalData.orderSourceType || 0)
  const [orderSourceTypeOptions, setOrderSourceTypeOptions] = useState([])

  useEffect(() => {
    setLoading(true)    
    if(sourceType === FilingSourceTypeIds.Miscellaneous.toString()){
      api.GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_MISCELLANEOUS(
        sourceType,
        miscellaneousModule,
        filingType,
        (res) => {
          dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
          dispatch({
            type: SET_OPTIONAL_DATA,
            optionalData: { sourceType, recordType, filingType, recordSubType, miscellaneousModule, orderSourceType },
          })
          setLoading(false)
        },
        (err) => {
          console.error('retrieving', err)
          setLoading(false)
        }
      )
    }
    else if (sourceType === FilingSourceTypeIds.Orders.toString()) {
      api.GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_ORDERS(
        sourceType,
        orderSourceType,
        recordType,
        filingType,
        (res) => {
          dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
          dispatch({
            type: SET_OPTIONAL_DATA,
            optionalData: { sourceType, recordType, filingType, recordSubType, miscellaneousModule, orderSourceType },
          })
          setLoading(false)
        },
        (err) => {
          console.error('retrieving', err)
          setLoading(false)
        }
      )
    }
    else {
      api.GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_SUB_TYPE(
        sourceType,
        recordType,
        filingType,
        recordSubType,
        (res) => {
          dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
          dispatch({
            type: SET_OPTIONAL_DATA,
            optionalData: { sourceType, recordType, filingType, recordSubType, miscellaneousModule, orderSourceType },
          })
          setLoading(false)
        },
        (err) => {
          console.error('retrieving', err)
          setLoading(false)
        }
      )
    }    
  }, [sourceType, recordType, filingType, recordSubType, miscellaneousModule, orderSourceType])

  const selectSourceType = (val) => {
    setSourceType(val)
    setRecordType(0)
    setRecordSubType(0)
    setFilingType(0)
    setOrderSourceType(0)
    val === '0' && setRecordTypeOptions([{ label: 'All', value: '0' }])
    val === '0' && setFilingTypeOptions([{ label: 'All', value: '0' }])
    val === '0'
      ? getSourceTypeOptions()
      : getLookupTypeDropdownOptions(
          sourceTypeOptions.find((option) => option.value === Number(val)).moduleName
        )
  }

  const selectMiscellaneousModule = (val) => {
    setMiscellaneousModule(val)
    if(val !== '0'){
      api.GET_MISCELLANEOUS_MODULE_FILING_TYPES(
        val,
        (res) => {
          setFilingTypeOptions([
            { label: 'All', value: '0' },
            ...res.map((t) => ({
              value: t.Id,
              label: t.Name
            })),
          ])          
        },
        (err) => console.error(err.message)
      )
    }
  }

  const getSourceTypeOptions = () => {
    api.GET_SOURCE_TYPE_OPTIONS(
      (res) => {
        setSourceTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
            moduleName: t.ModuleName,
          })),
        ])
        getLookupTypeDropdownOptions(
          res.find((option) => option.Id === Number(sourceType)).ModuleName
        )
      },
      (err) => console.error(err.message)
    )
  }

  const getLookupTypeDropdownOptions = (moduleName) => {
    if(moduleName === 'Miscellaneous'){
      api.GET_MISCELLANEOUS_MODULES(        
        (res) =>
        {
          res.sort((a,b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0))
          setMiscellaneousModuleOptions([
            { label: 'All', value: '0' },
            ...res.map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
          ])
          selectMiscellaneousModule(miscellaneousModule)          
        },
        (err) => {
          setMiscellaneousModuleOptions([{ label: 'All', value: '0' }])
          setFilingTypeOptions([{ label: 'All', value: '0' }])
          console.error(err.message)
        }
      )
      
    }    
    else{        
      api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
        moduleName,
        'FilingType',
        (res) =>
        {
          res.sort((a,b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0))
          setFilingTypeOptions([
            { label: 'All', value: '0' },
            ...res.map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
          ])
        },
        (err) => {
          setRecordTypeOptions([{ label: 'All', value: '0' }])
          setFilingTypeOptions([{ label: 'All', value: '0' }])
          console.error(err.message)
        }
      )

      if (moduleName === 'Orders') {
        api.GET_CONFIGURED_ORDER_SOURCE_TYPES(
          false,
          (res) => {
            setOrderSourceTypeOptions([
              ...res.map((t) => ({
                value: t.Id,
                label: t.ModuleName,
                moduleName: t.ModuleName,
              })),
            ])
          },
          (err) => {
            setOrderSourceTypeOptions([{ label: 'All', value: '0' }])
            setRecordTypeOptions([{ label: 'All', value: '0' }])
            setFilingTypeOptions([{ label: 'All', value: '0' }])
            console.error(err.message)
          }
        )
      } else {
        api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
          moduleName,
          'RecordType',
          (res) => {
            res.sort((a, b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0))
            setRecordTypeOptions([
              { label: 'All', value: '0' },
              ...res.map((t) => ({
                value: t.Id,
                label: t.Name,
              })),
            ])
          },
          (err) => {
            setRecordTypeOptions([{ label: 'All', value: '0' }])
            setFilingTypeOptions([{ label: 'All', value: '0' }])
          }
        )
      }
    }
  }

  useEffect(() => {
    getSourceTypeOptions()
  }, [])

  useEffect(() => {
    const option = sourceTypeOptions.find((type) => type.value === Number(sourceType))
    if (option) {
      setOptionsLoading(true)
      api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
        option.moduleName,
        'RecordSubType',
        (res) => {
          res.sort((a,b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0))
          setRecordSubTypeOptions([
            { value: '0', label: 'None' },
            ...res.map((t) => {
              return {
                value: t.Id,
                label: t.Name,
              }
            }),
          ])
          if (option.moduleName === 'Business') {            
            api.GET_BUSINESS_RECORD_SUB_TYPE_XREFS_BY_RECORD_TYPE(
              recordType,
              (res) => {
                setRecordSubTypeXref(res.BusinessRecordSubTypeIds)
                setOptionsLoading(false)
              },
              (err) => {
                console.error('retrieving', err)
                setRecordSubTypeXref([])
                setOptionsLoading(false)
              }
            )
          } else {
            setOptionsLoading(false)
          }
        },
        (err) => {
          console.warn('Module does not support RecordSubType')
          setOptionsLoading(false)
        }
      )
    }
    setRecordSubTypeOptions([{ label: 'None', value: '0' }])
  }, [sourceType, sourceTypeOptions, recordType])

  useEffect(() => {
    if (orderSourceType && orderSourceType !== '0' && orderSourceType !== 0) {
      const option = orderSourceTypeOptions.find((opt) => opt.value === Number(orderSourceType))
      if (option) {
        api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
          option.moduleName,
          'RecordType',
          (res) => {
            res.sort((a, b) => (a.Name > b.Name ? 1 : b.Name > a.Name ? -1 : 0))
            setRecordTypeOptions([
              { label: 'All', value: '0' },
              ...res.map((t) => ({
                value: t.Id,
                label: t.Name,
              })),
            ])
          },
          (err) => {
            setRecordTypeOptions([{ label: 'All', value: '0' }])
            console.error(err.message)
          }
        )
      }
    } else {
      setRecordTypeOptions([{ label: 'All', value: '0' }])
    }
  }, [orderSourceType, orderSourceTypeOptions])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Source Type"
        value={sourceType}
        onChange={(val) => {
          selectSourceType(val)
        }}
        options={sourceTypeOptions}
      />
      {sourceType === FilingSourceTypeIds.Orders.toString() ? <SelectBox
        label="Orders Source Type"
        noPlaceholder
        value={orderSourceType}
        onChange={(val) => {
          setOrderSourceType(val)
          setRecordType(0)
          setRecordSubType(0)
        }}
        options={orderSourceTypeOptions}
      /> : null}
      {sourceType !== FilingSourceTypeIds.Miscellaneous.toString() ? <SelectBox
        label="Record Type"
        noPlaceholder
        value={recordType}
        onChange={(val) => {
          setRecordType(val)
        }}
        options={recordTypeOptions}
      /> : null}
      {sourceType === FilingSourceTypeIds.Miscellaneous.toString() ? <SelectBox
        label="Miscellanous Module"
        noPlaceholder
        value={miscellaneousModule}
        onChange={(val) => {
          selectMiscellaneousModule(val)
        }}
        options={miscellaneousModuleOptions}
      /> : null}
      {recordSubTypeOptions.length > 1 ? (
        <SelectBox
          label="Record Sub Type"
          noPlaceholder
          value={recordSubType}
          onChange={(val) => {
            setRecordSubType(val)
          }}
          options={recordSubTypeOptions.filter(
            (opt) => opt.value === '0' || recordSubTypeXref.includes(+opt.value)
          )}
        />
      ) : null}
      <SelectBox
        label="Filing Type"
        noPlaceholder
        value={filingType}
        onChange={(val) => {
          setFilingType(val)
        }}
        options={filingTypeOptions}
      />
      {(loading || optionsLoading) && (
        <div className="type-loader">
          <Spinner size="small" themeColor="dark-neutral" />
        </div>
      )}
    </div>
  )
}

export default ReceiptItemToFilingTypeOptions
